/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */

import React, { memo, useState } from 'react';
import { Button } from 'reactstrap';
import PropType from 'prop-types';
import SpinnerCircles from '../../../../../../Spinner/SpinerCircles';
import '../../AdminTools.css';
import InfoPopup from '../../../../../../InfoPopup';
import { TOOLTIPS_TEXT } from '../../../../../../../lib/constants';
import DeviceLockRequiredModal from '../../../../DeviceLockRequiredModal';

const ModemRow = memo(({ simStateLoading, fetchSimStatus, onClick }) => {
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });
  const unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
 
  };
  return (
    <div className="modam-row mt-2 mb-2 mr-1">
      <h1 className="heading d-flex">
        Carrier SIM Activation Check
        <sup>
          <InfoPopup id="sim-activate" text={TOOLTIPS_TEXT.SIM_ACT_CHECK} />
        </sup>
      </h1>
      <Button
        disabled={simStateLoading}
        onClick={ () => {
          const divElement = document.getElementById('test-time-remaining');
          const isHidden = divElement?.hasAttribute('hidden') ?? true;
          if (isHidden) {
            setDcUpdatePopup({ show: true });
          } else {
            onClick()
          }

        }}
        color="primary"
        className="admin-tool-execute-btn"
      >
        {simStateLoading ? <SpinnerCircles /> : 'Execute'}
      </Button>
      <br />
      <DeviceLockRequiredModal
        isOpen={dcUpdatePopup.show}
        onCancel={() => {
          setDcUpdatePopup({ show: false, value: {} });
        }}
        onConfirm={() => {
          unLockBoxButton();
          setDcUpdatePopup({ show: false, value: {} });
        }}
      />
    </div>
  );
});

ModemRow.propTypes = {
  simStateLoading: PropType.bool,
  fetchSimStatus: PropType.func,
};

export default ModemRow;
